const SaleDetailsActionTypes = {
  FETCH_SALE_DETAILS_START: "fetch_sale_details_start",
  FETCH_SALE_DETAILS_SUCCESS: "fetch_sale_details_success",
  FETCH_SALE_DETAILS_FAILURE: "fetch_sale_details_failure",
  FETCH_SALE_DETAILS_RESPONSE_RESET: "fetch_sale_details_response_reset",
  FETCH_SALE_DETAILS_CHANGED: "fetch_sale_details_changed",

  CREATE_SALE_START: "create_sale_start",
  CREATE_SALE_SUCCESS: "create_sale_success",
  CREATE_SALE_FAILURE: "create_sale_failure",
  CREATE_SALE_RESPONSE_RESET: "create_sale_response_reset",
  CREATE_SALE_CHANGED: "create_sale_changed",

  UPDATE_SALE_START: "update_sale_start",
  UPDATE_SALE_SUCCESS: "update_sale_success",
  UPDATE_SALE_FAILURE: "update_sale_failure",
  UPDATE_SALE_RESPONSE_RESET: "update_sale_response_reset",
  UPDATE_SALE_CHANGED: "update_sale_changed",
};

export default SaleDetailsActionTypes;
